/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { TicketContainer } from '@appPlanApplication/tickets/TicketContainer';
import { FancyNineSlicePlane } from '@appCanvasCommon/graphics/FancyNineSlicePlane';
import { Texture } from 'pixi.js-legacy';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
/**
 *
 */
export abstract class TicketMeshComponent extends FancyNineSlicePlane implements ComponentInterface {
	public override visible = true;
	protected ticket: TicketContainer;
	protected canvasAngularLand: CanvasAngularLand;
	constructor(
		texture: Texture,
		canvasAngularLand: CanvasAngularLand,
		ticketContainer: TicketContainer,
		leftWidth?: number,
		topHeight?: number,
		rightWidth?: number,
		bottomHeight?: number
	) {
		super(texture, leftWidth, topHeight, rightWidth, bottomHeight);

		this.ticket = ticketContainer;
		this.canvasAngularLand = canvasAngularLand;
	}

	public override destroy(options?) {
		this.ticket = null;
		super.destroy();
	}
}
